export enum FluxCompressionMode  {
     NoCompression = 'NoCompression', //0 Le flux est a délivrer exclusivement sous forme non compressée
     DirectGZipOnly = 'DirectGZipOnly',//1, Le flux n'est à délivrer que sous forme de fichier(s) compressé(s) qui peuvent donc être écrit directement via une GZipStream
     UncompressedAndGZip = 'UncompressedAndGZip',//2, Le flux doit être délivré sous forme de fichier(s) non compressé(s) et aussi sous forme de fichier(s) .gz

}